import {CmsReactComponent} from 'components/cms/CmsReactComponent';
import {
    EntryOptions,
    PropertyDefinition,
} from "app/library/layout-builder";
import {HeroProps} from "./types";
import {MetaTypeEnum} from "app/shared";
import {HeroPropertyDefinitions} from 'components/cms/definitions';

export class HeroDefinitions extends CmsReactComponent<HeroProps> {
    static defaultProps = {};

    static schemaName = "hero";

    static propertyDefinitions: PropertyDefinition[] = HeroPropertyDefinitions;

    static options: EntryOptions = {
        meta: {
            use: true,
            allowedTypes: [
                MetaTypeEnum.Text,
                MetaTypeEnum.TextArea,
                MetaTypeEnum.SingleImage,
                MetaTypeEnum.Editor,
                MetaTypeEnum.Date,
                MetaTypeEnum.Dropdown,
            ],
        },
    };
}
